module.exports = __webpack_public_path__ + "media/images/riders/small/LEA_DAVISON-2e5dedd05ee7b6e302787f575ed503c1.png";